// Import polyfills
import './require-babel-polyfill';
import '@webcomponents/shadydom'
import smoothscroll from 'smoothscroll-polyfill';

/* eslint-enable */

// Missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Polyfill replaceWith - https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/replaceWith
function ReplaceWithPolyfill () {
  'use-strict';

  // For safari, and IE > 10
  const parent = this.parentNode;
  let i = arguments.length;
  let currentNode;

  if (!parent) {
    return;
  }

  // if there are no arguments
  if (!i && parent) {
    parent.removeChild(this);
  }
  // eslint-disable-next-line no-plusplus
  while (i--) { // i-- decrements i and returns the value of i before the decrement
    // eslint-disable-next-line prefer-rest-params
    currentNode = arguments[i];
    if (typeof currentNode !== 'object') {
      currentNode = this.ownerDocument.createTextNode(currentNode);
    } else if (currentNode.parentNode) {
      currentNode.parentNode.removeChild(currentNode);
    }
    // the value of "i" below is after the decrement
    if (!i) { // if currentNode is the first argument (currentNode === arguments[0])
      parent.replaceChild(currentNode, this);
    } else { // if currentNode isn't the first
      parent.insertBefore(currentNode, this.previousSibling);
    }
  }
}

if (!Element.prototype.replaceWith) {
  Element.prototype.replaceWith = ReplaceWithPolyfill;
}
if (!CharacterData.prototype.replaceWith) {
  CharacterData.prototype.replaceWith = ReplaceWithPolyfill;
}
if (!DocumentType.prototype.replaceWith) {
  DocumentType.prototype.replaceWith = ReplaceWithPolyfill;
}

// Polyfill replace - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat#Polyfill
if (!String.prototype.repeat) {
  // eslint-disable-next-line no-extend-native,func-names
  String.prototype.repeat = function (count) {
    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }

    let str = '' + this;
    // To convert string to integer.
    count = +count;
    // Check NaN
    // eslint-disable-next-line no-self-compare,eqeqeq
    if (count != count) {
      count = 0;
    }

    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }

    // eslint-disable-next-line eqeqeq
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }

    count = Math.floor(count);
    // eslint-disable-next-line eqeqeq
    if (str.length == 0 || count == 0) {
      return '';
    }

    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    // eslint-disable-next-line no-bitwise
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }

    const maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
      str += str;
      // eslint-disable-next-line no-plusplus
      count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  };
}

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// https://stackoverflow.com/questions/51912563/calling-window-scrollto-on-android-mobile-browser-causes-typeerror-no-functio
// https://github.com/iamdustan/smoothscroll
smoothscroll.polyfill();
